import { render, staticRenderFns } from "./AccountingStatementSpec.vue?vue&type=template&id=13e7c868&"
import script from "./AccountingStatementSpec.vue?vue&type=script&lang=js&"
export * from "./AccountingStatementSpec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports